<template>
    <div id="test">
        <button @click="test"></button>
    </div>
</template>

<script>
import PDFJS from 'pdfjs-dist';
import { mapActions, mapGetters, mapMutations, } from 'vuex';
import { log, } from '@/js/function';
import comProgress from '@/components/com-progress.vue';
export default {
    components: {
        comProgress,
    },
    data: () => ({
    }),
    methods: {
        ...mapActions(['actionUploadPdfFile', 'actionUploadFileByBase64']),
        test() { },
        uploadFile(e) {
            const inputFiles = e.target.files || e.dataTransfer.files;
            if (inputFiles.length) {
                const files = Array.from(inputFiles);
                this.actionUploadPdfFile({
                    file: files[0],
                }).then((url) => {
                    log('url', url);
                    PDFJS.disableWorker = true;
                    // Asynchronous download PDF as an ArrayBuffer
                    PDFJS.getDocument(url).then((pdf) => {
                        log(pdf.numPages);
                        // Fetch the first page
                        pdf.getPage(1).then((page) => {
                            const scale = 1.5;
                            const viewport = page.getViewport(scale);
                            const canvas = document.createElement("canvas");
                            const context = canvas.getContext('2d');
                            canvas.height = viewport.height;
                            canvas.width = viewport.width;
                            page.render({ canvasContext: context, viewport: viewport }).then(() => {
                                const image = document.getElementById('image');
                                image.src = canvas.toDataURL();
                                // this.actionUploadFileByBase64({
                                //     fileName: 'temp.png',
                                //     base64: canvas.toDataURL().substr(22),
                                //     index: 0,
                                // }).then(() => {

                                // });
                            });

                        });
                    });
                })

            }
        }
    },
    beforeCreate() { },
    created() { },
    beforeMount() { },
    mounted() { },
    beforeUpdate() { },
    updated() { },
    beforeDestroy() { },
    destroyed() { },
    computed: {},
    watch: {},
}

</script>

<style lang="scss">
@import '../style/variable.scss';
#test {}
</style>



// WEBPACK FOOTER //
// _test.vue?2e534e7a